"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linearInterpolationPoints = exports.linearInterpolationY = exports.linearInterpolationX = void 0;
var _validates_1 = require("./_validates");
var utils_1 = require("./utils");
function linearInterpolationX(p1, p2, y) {
    (0, _validates_1.validPoint)(p1);
    (0, _validates_1.validPoint)(p2);
    if ((0, utils_1._eq)(p1[1], p2[1]))
        return p1[0];
    return p1[0] + ((y - p1[1]) * (p2[0] - p1[0])) / (p2[1] - p1[1]);
}
exports.linearInterpolationX = linearInterpolationX;
function linearInterpolationY(p1, p2, x) {
    (0, _validates_1.validPoint)(p1);
    (0, _validates_1.validPoint)(p2);
    if ((0, utils_1._eq)(p1[0], p2[0]))
        return p1[1];
    return p1[1] + ((x - p1[0]) * (p2[1] - p1[1])) / (p2[0] - p1[0]);
}
exports.linearInterpolationY = linearInterpolationY;
var _calcLinearInterpolationPoint = function (i, p1, p2, partition) {
    var div = Math.floor(partition);
    if ((0, utils_1._eq)(p1[0], p2[0])) {
        return [p1[0], p1[1] + (i * (p2[1] - p1[1])) / (div + 1)];
    }
    else if ((0, utils_1._eq)(p1[1], p2[1])) {
        return [p1[0] + (i * (p2[0] - p1[0])) / (div + 1), p1[1]];
    }
    var x = p1[0] + (i * (p2[0] - p1[0])) / (div + 1);
    return [x, linearInterpolationY(p1, p2, x)];
};
function linearInterpolationPoints(p1, p2, userOptions) {
    if (userOptions === void 0) { userOptions = {}; }
    (0, _validates_1.validPoint)(p1);
    (0, _validates_1.validPoint)(p2);
    var options = Object.assign({
        partition: 0,
    }, userOptions);
    (0, _validates_1.validNumber)(options.partition);
    if (options.partition <= 0)
        return [p1, p2];
    var ret = [];
    for (var i = 0; i < options.partition + 1; i++) {
        ret.push(_calcLinearInterpolationPoint(i, p1, p2, options.partition));
    }
    ret.push(p2);
    return ret;
}
exports.linearInterpolationPoints = linearInterpolationPoints;
